
/* ADMIN PAGES */
// import AdminPage from 'pages/admin/.....';

/* FRONT PAGES */
import VirtualCave from 'pages/front/virtual-cave';

/* COMPONENTS */
// import Item from 'components/...';

var componentIncludes = {
    /* ADMIN PAGES */
    // 'adminPage': AdminPage,

    /* FRONT PAGES */
    'VirtualCave': VirtualCave,

    /* COMPONENTS */
    // 'Item': Item,
};

if(window.page && componentIncludes[window.page]) {
    console.log(`Js: Page '${window.page}' Init`);
    new componentIncludes[window.page];
    console.log(`Js: Page '${window.page}' Init Done`);
}

window.components = {};
let components = document.querySelectorAll('[data-js-component-load]');
if(components.length) {
    for(const component of components) {
        const name = component.getAttribute('data-js-component-load');
        if(componentIncludes[name]) {
            window.components[name] = [];
            window.components[name].push(new componentIncludes[name](component));
        }
    }
}

// always load this
// SomeClass();

console.log('loaded components', window.components)